import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MacroStepId, StepId } from 'models';
import { ProcessComponent } from './components/process/process.component';
import { ActivationOtpComponent } from './components/steps/activation-otp/activation-otp.component';
import { ActivationComponent } from './components/steps/activation/activation.component';
import { AddressComponent } from './components/steps/address/address.component';
import {ConsentsComponent} from './components/steps/consents/consents.component';
import { ContactsComponent } from './components/steps/contacts/contacts.component';
import {CouponComponent} from './components/steps/coupon/coupon.component';
import { CustomerComponent } from './components/steps/customer/customer.component';
import { DigitalOnboardingIccidComponent } from './components/steps/digital-onboarding-iccid/digital-onboarding-iccid.component';
import { DocumentComponent } from './components/steps/document/document.component';
import {OfferExtrasComponent} from './components/steps/offer-extras/offer-extras.component';
import { PaymentMethodComponent } from './components/steps/payment-method/payment-method.component';
import { PaymentComponent } from './components/steps/payment/payment.component';
import { ShippingMethodComponent } from './components/steps/shipping-method/shipping-method.component';
import { SimTypeComponent } from './components/steps/sim-type/sim-type.component';
import {SummaryComponent} from './components/steps/summary/summary.component';
import { WinbackComponent } from './components/steps/winback/winback.component';
import { BackUrlGuard } from './guards/back-url/back-url.guard';
import { CanDeactivateGuard } from './guards/can-deactivate/can-deactivate.guard';

const routes: Routes = [
  {
    path: '',
    data: { animation: MacroStepId.Process },
    component: ProcessComponent,
    children: [
      {
        path: StepId.Shipping,
        data: { animation: StepId.Shipping },
        component: ShippingMethodComponent
      },
      {
        path: StepId.Coupon,
        data: { animation: StepId.Coupon },
        component: CouponComponent
      },
      {
        path: StepId.Consents,
        data: { animation: StepId.Consents },
        component: ConsentsComponent
      },
      {
        path: StepId.Customer,
        data: { animation: StepId.Customer },
        component: CustomerComponent,
        canDeactivate: [ BackUrlGuard ]
      },
      {
        path: StepId.Document,
        data: { animation: StepId.Document },
        component: DocumentComponent,
        canDeactivate: [ CanDeactivateGuard ]
      },
      {
        path: StepId.Contacts,
        data: { animation: StepId.Contacts },
        component: ContactsComponent,
        canDeactivate: [ CanDeactivateGuard ]
      },
      {
        path: StepId.Activation,
        data: { animation: StepId.Activation },
        component: ActivationComponent,
        canDeactivate: [ CanDeactivateGuard ]
      },
      {
        path: StepId.ActivationOtp,
        data: { animation: StepId.ActivationOtp },
        component: ActivationOtpComponent,
        canDeactivate: [ CanDeactivateGuard ]
      },
      {
        path: StepId.Address,
        data: { animation: StepId.Address },
        component: AddressComponent,
        canDeactivate: [ CanDeactivateGuard ]
      },
      {
        path: StepId.PaymentMethod,
        data: { animation: StepId.PaymentMethod },
        component: PaymentMethodComponent
      },
      {
        path: StepId.Payment,
        data: { animation: StepId.Payment },
        component: PaymentComponent
      },
      {
        path: StepId.Winback,
        data: { animation: StepId.Winback },
        component: WinbackComponent
      },
      {
        path: StepId.FDOIccid,
        data: { animation: StepId.FDOIccid },
        component: DigitalOnboardingIccidComponent
      },
      {
        path: StepId.Sim,
        data: { animation: StepId.Sim },
        component: SimTypeComponent
      },
      {
        path: StepId.OfferExtras,
        data: { animation: StepId.OfferExtras },
        component: OfferExtrasComponent
      },
      {
        path: StepId.Summary,
        data: { animation: StepId.Summary },
        component: SummaryComponent
      },
      {
        path: '',
        redirectTo: StepId.Customer,
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/not-found'
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class ProcessRoutingModule {}
